import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as ClockHistorySvg } from '../../assets/clock-history.svg';

export const ClockHistoryIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={ClockHistorySvg} {...props} />;
};
